module.exports = __webpack_public_path__ + "static/d13-ded6e913fb480df5306c8cd74786ed19.png";